const translations = {
    title: {
        homePage: 'Blocklist',
        exemples: 'Examples',
        systemInfo: 'System info',
        userInfo: 'User info',
        connectDatabase: 'Connect Database',
    },
    paragraph: {
        homeDescription: {
            part1: 'This is a basic plugin template.',
            part2: 'Edit <1>src/pages/Home.js</1> and save to reload.'
        }
    },
    link: {
        blipDataExample: 'Get blip data',
        swrExemple: 'SWR fetch data'
    },
    button: {
        repository: 'Visit the Repository',
        connect: 'Connect'
    },
    menu: {
        goBack: 'Back'
    },
    name: 'Name',
    shortName: 'Short name',
    email: 'E-mail',
    phone: 'Phone',
    identity: 'Identity',
    identifier: 'Identifier',
    language: 'Language',
    accessKey: 'Access key',
    template: 'Template',
    creationDate: 'Creation date',
    instance: {
        connection: {
            connected: "Connected Database",
            disconnected: "Disconnected Database",
            failed: "Databsae connection failed",
        }
    }
};

export default translations;
